import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M3.958 7.292c0-.92.747-1.667 1.667-1.667h8.75c.92 0 1.667.746 1.667 1.667v7.083c0 .92-.747 1.667-1.667 1.667h-8.75c-.92 0-1.667-.747-1.667-1.667V7.292Zm2.709-3.334v2.917m6.666-2.917v2.917M6.458 8.958h7.084" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);